/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';

const intelligentFormatObj = require('dibs-currency-helpers/intelligentFormatObj');

module.exports = {
    /**
     *
     * @param {object} copy
     * @param {boolean} isSoldIndividually
     * @param {number|string} price
     * @param {string} currency
     * @returns {{string, abbreviation, perItem: string}}
     */
    formatPrice({copy = {}, isSoldIndividually, price, currency}) {
        const priceStates = copy.priceStates || {};
        const {sign, currencySymbol, number, abbreviation} = intelligentFormatObj(price, currency);
        const string = `${sign} ${currencySymbol}${number}`.trim();
        let perItem = '';

        if (isSoldIndividually) {
            perItem += ` ${priceStates.perItem}`;
        }

        return {
            string,
            abbreviation,
            perItem
        };
    },

    calculatePercentageOff({net, retail}) {
        const percentage = (net / retail) * 100;
        return `${Math.round(100 - percentage)}%`;
    }

};



// WEBPACK FOOTER //
// ./assets/js/components/Price/helpers.es.js